import classNames from 'classnames';
import isEmpty from '@tinkoff/utils/is/empty';

import {TypographySize, useTypography} from '../../../hooks/typography';
import {trimFilename} from '../../../utils/attachments/utils';
import {Image} from '../../../atoms/image';

import styles from './attachment-thumbnail.module.css';

type Props = {
    className?: string;
    src?: string;
    fileExtension: string;
    fileName: string;
    fileType: string;
};

export const AttachmentThumbnail = ({src, fileExtension, fileName, fileType, className}: Props) => {
    const [textCls] = useTypography([
        {
            size: TypographySize.BodyL,
            noDefaultColor: true,
        },
    ]);

    const placeholder = <span className={classNames(styles.thumbnail, className)} />;

    const fallback = (
        <span className={classNames(styles.thumbnail, className)} data-type={fileType}>
            <span className={classNames(styles.fallback, textCls)}>{trimFilename(fileExtension, 4)}</span>
        </span>
    );

    return isEmpty(src) ? (
        fallback
    ) : (
        <Image
            src={src}
            alt={fileName}
            className={classNames(styles.thumbnail, className)}
            placeholder={placeholder}
            fallback={fallback}
        />
    );
};
